// eslint-disable-next-line import/prefer-default-export
export const addDerived = (item, ddaMaskType, fspId) => {
  return {
    ...item,
    id: `${ddaMaskType}-${item.id}`,
    maskTypeDerived: ddaMaskType,
    fspIdDerived: fspId,
  };
};
